import { render, staticRenderFns } from "./_kissh5.vue?vue&type=template&id=3b65414d&lang=pug&"
import script from "./_kissh5.vue?vue&type=script&lang=js&"
export * from "./_kissh5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports